// Import fetchWrappera do obsługi żądań HTTP
import { fetchWrapper } from "@/helpers/fetch-wrapper";
// Import store z filtrami archiwalnych pomiarów
import { useArchivalFiltersStore } from "@/stores/archivalFilters";

// Serwis obsługujący zapytania dotyczące archiwalnych pomiarów pojazdów
class ArchivalMeasurementsService {

  // Tworzy query string na podstawie aktualnych filtrów w store
  // getQueryString() {
  //   const filtersStore = useArchivalFiltersStore();
  //   const keys =
  //     filtersStore && filtersStore.filters
  //       ? Object.keys(filtersStore.filters)
  //       : [];
  //   return keys.length > 0
  //     ? "&" +
  //         keys
  //           .map((key) =>
  //             filtersStore.filters[key] &&
  //             (filtersStore.filters[key].length > 0 ||
  //               filtersStore.filters[key] > 0)
  //               ? key + "=" + filtersStore.filters[key]
  //               : ""
  //           )
  //           .join("&")
  //     : "";
  // }

    getQueryString() {
        const filtersStore = useArchivalFiltersStore();
        const filters = filtersStore?.filters ?? {};

        // kompatybilność: jeśli gdzieś jeszcze ustawiane jest blacklistHit, mapujemy na onBlackList
        if (filters.blacklistHit !== undefined && filters.onBlackList === undefined) {
            filters.onBlackList = filters.blacklistHit;
            delete filters.blacklistHit;
        }

        const parts = [];

        Object.entries(filters).forEach(([key, value]) => {
            if (value === undefined || value === null) return;

            // boolean: wysyłamy tylko true (false pomijamy jak dotychczas)
            if (typeof value === "boolean") {
                if (value === true) parts.push(`${encodeURIComponent(key)}=true`);
                return;
            }

            // array (np. locations, laneNumbers, ctg8p1)
            if (Array.isArray(value)) {
                if (value.length === 0) return;
                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.join(","))}`);
                return;
            }

            // number/string: wysyłamy też 0
            const str = String(value);
            if (str.length === 0) return;
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(str)}`);
        });

        return parts.length ? "&" + parts.join("&") : "";
    }

    // Pobiera listę pojazdów archiwalnych (z paginacją)
  getAll(page, limit) {
    const filter = this.getQueryString();
    // console.log('Filter string:', filter);
    if (!filter) {
      return Promise.resolve();
    }
    // Zwraca pojazdy z danymi o osiach i zdjęciami
    return fetchWrapper.getWithCount(
      `${process.env.VUE_APP_API_URL}/arch-vehicles?${filter}&page=${page}&limit=${limit}&withAxles=true&withImages=true`
    );
  }

  // Pobiera pojazdy oznaczone tagami prywatnymi
  getAllWithTags() {
    const filter = this.getQueryString();
    if (!filter) {
      return Promise.resolve();
    }

    return fetchWrapper.getWithCount(
      `${process.env.VUE_APP_API_URL}/arch-vehicles?${filter}&tags=[{%22tagType%22:1,%22private%22:true}]&withTags=true&withAxles=true&withImages=true`
    );
  }

  // Pobiera tagi dla wybranego pojazdu (wg ID, lokalizacji i daty)
  getTags(id, locationId, createdAt) {
    const queryParams = new URLSearchParams({
      locationId,
      createdAt
    }).toString();
  
    return fetchWrapper.get(
      `${process.env.VUE_APP_API_URL}/arch-vehicles/${id}/tags?${queryParams}`
    );
  }  

  // Dodaje tag do pojazdu archiwalnego
  addTag(id, locationId, createdAt) {
    const queryParams = new URLSearchParams({
      locationId,
      createdAt
    }).toString();
  
    const tagData = {
      private: true,
      type: 1,
      data: {},
      description: 'Normal tag'
    };
  
    return fetchWrapper.post(
      `${process.env.VUE_APP_API_URL}/arch-vehicles/${id}/tags?${queryParams}`,
      tagData
    );
  }  

  // Usuwa tag z pojazdu archiwalnego
  removeTag(id, tagId, locationId, createdAt) {
    const queryParams = new URLSearchParams({
      locationId,
      createdAt
    }).toString();
  
    return fetchWrapper.delete(
      `${process.env.VUE_APP_API_URL}/arch-vehicles/${id}/tags/${tagId}?${queryParams}`
    );
  }

  // Pobiera szczegóły pojedynczego pojazdu archiwalnego
  get(id, location, createdAt) {
    return fetchWrapper.get(
      `${process.env.VUE_APP_API_URL}/arch-vehicles/${id}?createdAt=${createdAt}&locationId=${location}&withDataImages=true`
    );
  }

  // Pobiera obrazek (np. zdjęcie pojazdu) - pełna jakość
  getImage(id, typeId, location, createdAt) {
    return fetchWrapper.getBlob(
      `${process.env.VUE_APP_API_URL}/arch-vehicles/${id}/images/${typeId}?locationId=${location}&createdAt=${createdAt}`
    );
  }

  // Pobiera obrazek w mniejszej skali (np. do podglądu)
  getImageWithScale(id, typeId, location) {
    return fetchWrapper.getBlob(
      `${process.env.VUE_APP_API_URL}/arch-vehicles/${id}/images/${typeId}?locationId=${location}&scale=0.3`
    );
  }

  // Pobiera ZIP (np. do eksportu danych) - typ do wyboru (pdf, csv itp.)
  getZip(type) {
    return fetchWrapper.get(
      `${process.env.VUE_APP_API_URL}/arch-vehicles/report?withTags=true&reportType=${type}` +
        this.getQueryString()
    );
  }

  // Pobiera ZIP pojazdów oznaczonych tagami prywatnymi (np. do eksportu)
  getTagsZip(type) {
    return fetchWrapper.get(
      `${process.env.VUE_APP_API_URL}/arch-vehicles/report?withTags=true&tags=[{%22tagType%22:1,%22private%22:true}]&reportType=${type}` +
        this.getQueryString()
    );
  }

  // Pobiera ZIP z danymi pojedynczego pojazdu (po ID)
  getVehicleZip(measurementId, type) {
    return fetchWrapper.get(
        `${process.env.VUE_APP_API_URL}/arch-vehicles/report?id=${measurementId}&withTags=true&reportType=${type}` +
        this.getQueryString()
    );
  }

  // Pobiera plik binarny (np. ZIP, PDF) z API
  fetch(zip) {
    // Jeśli ścieżka zawiera api/v1, usuń przedrostek
    let zipNoStart = zip.includes("api/v1") ? zip.substr(7) : zip;
    return fetchWrapper.getBlob(process.env.VUE_APP_API_URL + zipNoStart);
  }
}

// Eksport instancji serwisu (singleton)
export default new ArchivalMeasurementsService();
